export const DEFAULT_ASPECT_RATIO = 1;